import React, {useState} from 'react';
import ReactTableBase from "../Table/ReactTableBase";
import {Link} from "react-router-dom";
import Routing from "../../services/routing";
import renderCellRating from "../Table/RenderCellRating";
import '../../index.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload} from "@fortawesome/free-solid-svg-icons";
import {exportToCsv} from "../../services/FileService";
import {filteredDataTabSearch, getNestedValue} from "../../services/UtilsService";
import TableSearch from "../Table/TableSearch";
import DateService from "../../services/DateService";


const SeancesStatsTable = ({ seances }) => {
    const data = React.useMemo(() => seances, [seances]);
    const [searchQuery, setSearchQuery] = useState("");
    const handleSearch = (event) => { setSearchQuery(event.target.value);};

    const renderCellPlaces = ({ row, value }) => {
        const isFull = value >= row.original.participantsMax;
        const isHalf = value >= row.original.participantsMax / 2;
        const isAlmostHalf = value <= row.original.participantsMax / 2;
        const isAlmostFull = value >= row.original.participantsMax * 0.75;
        const isAlmostEmpty = value <= row.original.participantsMax * 0.33;
        const isEmpty = value === 0;

        const styles = {
            padding: "5px 10px",
            borderRadius: "5px",
        }

        let classe;

        if (isFull) {
            classe = "bg7";
        // } else if (isAlmostFull) {
        //     classe = "bg3";
        // } else if (isHalf) {
        //     classe = "bg4";
        // } else if (isEmpty) {
//
        // } else if (isAlmostEmpty) {
        //     classe = "bg7";
        // } else if (isAlmostHalf) {
        //     classe = "bg5";
        }

        return (
            <div>
                <span style={styles} className={classe}>{ value } / {row.original.participantsMax}</span>
            </div>
        );
    }

    const renderCellId = ({ row }) => {
        return (
            <div>
                {row.original.id}
            </div>
        );
    }

    const renderCellType = ({ row, value }) => {
        return (
            <div style={{
                color: row.original.type.clr_font,
                backgroundColor: row.original.type.clr_bg,
                padding: "5px 10px",
                borderRadius: "5px",
            }}>
                <Link style={{ textDecoration: "none" }} to={Routing.generate({route: Routing.routes.seance, params: { id: row.original.id }})}>
                    {row.original.type.label}
                </Link>
            </div>
        );
    }

    const renderCellDate = ({ row }) => {
        const classe = new Date(row.original.date) < new Date() ? "bg0" : "bg3";
        const styles = {
            padding: "5px 10px",
            borderRadius: "5px",
        }

        return (
            <div style={styles} className={classe}>
                {DateService.formatDate(row.original.date)}
            </div>
        );
    }

    const renderCellPasVenus = ({ row }) => {
        const styles = {
            padding: "5px 10px",
            borderRadius: "5px",
        }

        // Si seance dans le futur, pas de pas venus
        if (new Date(row.original.date) > new Date()) {
            return (<div title={"Séance dans le futur"}>
                <span className={"bg0"} style={styles}>
                N/A
                </span>
            </div>);
        }

        // si + de 50% des inscrits ne sont pas venus
        // const isBad = row.original.nb_pas_venus >= (row.original.placesReservees / 2);
        const isGood = row.original.nb_pas_venus === 0;
        const isAlmostGood = row.original.nb_pas_venus <= (row.original.placesReservees / 10);
        const isAlmostBad = row.original.nb_pas_venus <= (row.original.placesReservees / 4);
        const isHalf = row.original.nb_pas_venus >= (row.original.placesReservees / 4);

        const isBad = row.original.nb_pas_venus > 0;

        let classe;

        if (isGood) {

        } else if (isBad) {
            classe = "bg2";
        } else if (isAlmostBad) {
            classe = "bg3";
        } else if (isHalf) {
            classe = "bg4";
        } else if (isAlmostGood) {
            classe = "bg6";
        }

        return (
            <div>
                <span className={classe} style={styles}>
                { row.original.nb_pas_venus }
                </span>
            </div>
        );
    }

    const renderCellPresences = ({ row, value }) => {
        // const isFull = value >= row.original.placesReservees;
        // const isHalf = value >= row.original.placesReservees / 2;
        // const isAlmostFull = value >= row.original.placesReservees * 0.75;
        // const isAlmostEmpty = value <= row.original.placesReservees * 0.25;
        const isEmpty = value === 0;

        const isFull = value >= row.original.placesReservees;

        const styles = {
            padding: "5px 10px",
            borderRadius: "5px",
        }

        let classe;


        if (row.original.placesReservees === 0) {

        } else if (isFull) {
            classe = "bg7";
        // } else if (isAlmostFull) {
        //     classe = "bg6";
        // } else if (isHalf) {
        //     classe = "bg4";
        // } else if (isAlmostEmpty) {
        //     classe = "bg2";
        } else if (isEmpty) {
            classe = "bg0";
        }

        return (
            <div>
                <span className={classe} style={styles}>{ value }</span>
            </div>
        );
    }

    const renderCellAttentes = ({ row, value }) => {
        const styles = {
            padding: "5px 10px",
            borderRadius: "5px",
        }

        let classe;

        if (value === 0) {
        // } else if (value > 10) {
        //     classe = "bg1";
        // } else if (value > 6) {
        //     classe = "bg2";
        // } else if (value > 3) {
        //     classe = "bg3";
        } else if (value >= 1) {
            classe = "bg4";
        // } else if (value === 1) {
        //     classe = "bg5";
        } else {
            classe = "bg0";
        }

        return (
            <div>
                <span className={classe} style={styles}>{ value }</span>
            </div>
        );
    }

    const handleDownloadCSV = () => {
        exportToCsv("seances_stats.csv", seances, columns);
    }

    const columns = [
        {
            Header: 'Activité',
            accessor: 'type.label',
            Cell: renderCellType,
        },
        {
            Header: 'Date',
            accessor: 'date',
            Cell: renderCellDate,
        },
        {
            Header: 'Places',
            accessor: 'placesReservees',
            Cell: renderCellPlaces
        },
        {
            Header: 'Présences',
            accessor: 'nb_presences',
            Cell: renderCellPresences
        },
        {
            Header: 'Liste d\'attente',
            accessor: 'nb_attentes',
            Cell: renderCellAttentes
        },
        {
            Header: 'Annulations',
            accessor: 'nb_annulations',
        },
        {
            Header: 'Pas venus',
            accessor: 'nb_pas_venus',
            Cell: renderCellPasVenus,
        },
        {
            Header: 'Satisfaction globale',
            accessor: 'satisfaction_globale',
            Cell: renderCellRating,
        },
    ];

    const filteredSeances = filteredDataTabSearch(seances, columns, searchQuery);

    return (
        <>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", margin: "12px 0 12px 0", padding: "0 8px 0 0"}}>
                <TableSearch onSearch={handleSearch} value={searchQuery} />

                <button className={"btn"} style={{
                    backgroundColor: "#e7f1e6",
                    border: "2px solid var(--clr-accent)",
                    height: "fit-content",

                }} onClick={handleDownloadCSV} title={"Télécharger le tableau"}>
                    <FontAwesomeIcon icon={faDownload}/>
                </button>
            </div>

            <ReactTableBase dataSource={filteredSeances} columnsData={columns} />
        </>
    );
};

export default SeancesStatsTable;
